
function toCurrencyFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function toNumberFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}
function setDefaultWizardStart(){
    const url = window.location.href;
   

       if(url.indexOf('/pages/gemstones') >-1 || url.indexOf('/pages/gemstone-detail') >-1 || $('.product.non-dyor-product').attr('data-template') == 'gemstone'){
            wizard_gemstoneStart='StartWithDiamond';
            wizardStart='StartWithDiamond';
            localStorage.setItem("wizardStart", JSON.stringify(wizard_gemstoneStart));
        }
        else {
            wizard_gemstoneStart='StartWithSetting';
            wizardStart='StartWithSetting';
            localStorage.setItem("wizardStart", JSON.stringify(wizard_gemstoneStart));
        }
    
    wizard_gemstone.stepId=1; 
    return wizardStart;
}

function setWizardStepId(){
    let startWith = JSON.parse(localStorage.getItem('wizardStart'));
    let wizardActualPage = sessionStorage.getItem('wizardActualPage');
    switch(wizardActualPage){
        case 'dyor-diamond-detail':
            if(startWith == 'StartWithDiamond'){
                wizard_gemstone.stepId=1;
            }
            else {
                wizard_gemstone.stepId=2;
            }wizardStart
            break;
        case 'dyor-diamonds':
            if(startWith == 'StartWithDiamond'){
                wizard_gemstone.stepId=1;
            }
            else {
                wizard_gemstone.stepId=2;
            }
            break;
        case 'dyor-wizard-settings-collection':
            if(startWith == 'StartWithDiamond'){
                wizard_gemstone.stepId=2;
            }
            else {
                wizard_gemstone.stepId=1;
            }
            break;
        case 'dyor-wizard-completering':
                wizard_gemstone.stepId=3;
            break;
        default:
            wizard_gemstone.stepId=1;
            break;
    }
}

function getCaratDictionaryValueForWizard(carat){
    // get the integer part of the carat
    // Determine the lower bound
  let lowerBound = Math.floor(carat);
  let remainder = carat - lowerBound;
  let topNumber;
  if (remainder < 0.30) {
    topNumber = lowerBound + 0.29;
  } else if (remainder < 0.46) {
    topNumber = lowerBound + 0.45;
  } else {
    topNumber = lowerBound + 0.99;
  }

  // Increment the lower bound for the next range
  let increment = (lowerBound % 2 === 0) ? 0.46 : 0.53;
  if (carat > topNumber) {
    topNumber = lowerBound + increment + 0.99;
  }

  return 'dyo_carat_' + topNumber.toFixed(2).replace(".","-");
}

function changeWizardSelection(type){
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
    
    switch(type){
        case 'setting':
         var diamond_step = localStorage.getItem("complete_ring_step");
               if(diamond_step != null){
               localStorage.removeItem("complete_ring_step");
               }
            if(wizardInfo != null){
                wizardInfo.setting_product_handle = null;
                wizardInfo.setting_variant_id = null;
                wizardInfo.setting_product_handle = null;
                wizardInfo.setting_image_url = null;
                wizardInfo.setting_variant_price = null;
                wizardInfo.setting_selected_shape = null;
                wizardInfo.setting_selected_side_carat_weight = null;
                wizardInfo.setting_variant_sku = null;
                wizardInfo.setting_max_carat_size = null;
                wizardInfo.setting_min_carat_size = null;
                wizardInfo.setting_selected_carat_size = null;
                wizardInfo.setting_selected_metal = null;
                wizardInfo.setting_allowed_shapes = null;
                wizardInfo.setting_allowed_ring_sizes = null;
                wizardInfo.setting_product_id = null;
                localStorage.setItem("wizardInfo_gemstone", JSON.stringify(wizardInfo));
            }
            if(wizardInfo.gemstone_id){
                   window.location.href = `/collections/engagement-ring-settings-with-gemstone`;
            }
            else {
                // No stone selected neither Setting, we need to remove all the info from the wizard because it is empty
                localStorage.removeItem('gemstone_template');
                localStorage.removeItem('metal_gemstone');
                localStorage.removeItem('gemstone_shape');
                window.localStorage.removeItem('wizardSessionDate');
                window.localStorage.removeItem('latestSearch');
                if(wizardInfo.gemstone_shape != null && wizardInfo.gemstone_shape != undefined){
                   var shape = wizardInfo.gemstone_shape.toLowerCase();
                }
              if(window.location.href.indexOf('stone=') >-1){
                   var stone_name = window.location.href.split('stone=')[1];
                 window.location.href = `/collections/engagement-ring-settings-with-gemstone?gemstone=${stone_name}`;
                 } else{
                 window.location.href = `/collections/engagement-ring-settings-with-gemstone/`;
                 }
               
            }
          break;
        case 'diamond':
            var diamond_step = localStorage.getItem("diamond_page_step");
             if(diamond_step != null){
             localStorage.removeItem("diamond_page_step");
             }
            if(wizardInfo != null){
                wizardInfo.gemstone_id = null;
                wizardInfo.gemstone_image_url = null;
                localStorage.setItem("wizardInfo_gemstone", JSON.stringify(wizardInfo));
            }
            if(!wizardInfo.setting_variant_id || wizardInfo.setting_variant_id == 0){

                //There's no setting selected so we should clear the LocalStorage because the user is restarting the wizard
                localStorage.removeItem('gemstone_template');
                localStorage.removeItem('wizardInfo_gemstone');
                localStorage.removeItem('metal_gemstone');
                localStorage.removeItem('gemstone_shape');
                window.localStorage.removeItem('wizardSessionDate');
                window.localStorage.removeItem('latestSearch');
                window.location.href = '/pages/gemstones';
            }
            else {
              window.location.href = '/pages/gemstones';
            }
            break;
    }
}
function loadWizard(){
    let screenWidth = screen.width;
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
    let wizardSessionDate = JSON.parse(localStorage.getItem('wizardSessionDate'));
    if(wizardSessionDate){
        // let's parse the date
        let date = new Date(wizardSessionDate);
        //if more than 4 hours have passed let's clear the wizard/localStorage and all that stuff
        if((new Date() - date) > 14400000){
            localStorage.removeItem('wizardInfo_gemstone');
            localStorage.removeItem('gemstone_template');
            localStorage.removeItem('metal_gemstone');
            localStorage.removeItem('gemstone_shape');
            localStorage.removeItem('wizardSessionDate');
            localStorage.removeItem('latestSearchGemstone');
            localStorage.removeItem('wizardStart');
            localStorage.removeItem('wizardInfo');
            localStorage.removeItem('wizardStart');
            localStorage.removeItem('wizardSessionDate');
            localStorage.removeItem('latestSearch');
            localStorage.removeItem('diamon_shape');
            localStorage.removeItem('metal_name');
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
        else {
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
    }
    else {
        // Not even a date, let's clear the localStorage
        localStorage.removeItem('gemstone_template');
        localStorage.removeItem('wizardInfo_gemstone');
        localStorage.removeItem('metal_gemstone');
        localStorage.removeItem('gemstone_shape');
        localStorage.removeItem('wizardStart');
        localStorage.removeItem('wizardSessionDate');
        localStorage.removeItem('latestSearchGemstone');
        localStorage.removeItem('wizardInfo');
        localStorage.removeItem('wizardStart');
        localStorage.removeItem('wizardSessionDate');
        localStorage.removeItem('latestSearch');
        localStorage.removeItem('diamon_shape');
        localStorage.removeItem('metal_name');
        localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));

    }
    // Let's do some validations
    // Is wizardStart null? If so, let's set it to default
    if (wizardStart == null || wizardStart == '' || wizardStart == 'undefined') {
       wizardStart = setDefaultWizardStart();
    }
    else {
        // If start with setting we need to check that we have a setting selected
        if (wizardStart == 'StartWithSetting') {
            let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
            if (wizardInfo == null || wizardInfo == '' || wizardInfo == 'undefined') {
                wizardStart = setDefaultWizardStart();   
            }
            else {
                if (wizardInfo.setting_product_handle == null || wizardInfo.setting_product_handle == '' || wizardInfo.setting_product_handle == 'undefined') {
                    //Let's check if there's a diamond, if there's a diamond then we have to change the startWith to diamond
                    if (wizardInfo.gemstone_id != null && wizardInfo.gemstone_id != '' && wizardInfo.gemstone_id != 'undefined') {
                        wizard_gemstoneStart='StartWithDiamond';
                        wizardStart='StartWithDiamond';
                        localStorage.setItem("wizardStart", JSON.stringify(wizard_gemstoneStart));
                        
             
                    }
                }
            }
        }
        else {
            // If start with diamond we need to check that we have a diamond selected
            if (wizardStart == 'StartWithDiamond') {
                let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
                if (wizardInfo == null || wizardInfo == '' || wizardInfo == 'undefined') {
                    wizardStart = setDefaultWizardStart();   
                }
                else {
                    if (wizardInfo.gemstone_id == null || wizardInfo.gemstone_id == '' || wizardInfo.gemstone_id == 'undefined') {
                        //Let's check if there's a setting, if there's a setting then we have to change the startWith to setting
                        if (wizardInfo.setting_product_handle != null && wizardInfo.setting_product_handle != '' && wizardInfo.setting_product_handle != 'undefined') {
                            wizard_gemstoneStart='StartWithSetting';
                            wizardStart='StartWithSetting';
                            localStorage.setItem("wizardStart", JSON.stringify(wizard_gemstoneStart));
                                
                        }
                    }
                }
            }
        }
        setWizardStepId();

    }

    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
    if (screenWidth >= 800) {
        let step3
        switch (wizardStart) {
            case 'StartWithSetting':        
                loadDesktopStartWithSettingWizard();
                break;

            case 'StartWithDiamond':                
                loadDesktopStartWithDiamondWizard();
                break;

            default:
                break;
        }

    } else {
        loadMobileWizard();
        
    }
}

function loadDesktopStartWithSettingWizard(){
    let wizardInfo;
    let currentCurrency = Shopify.currency.active;
    let currentCurrencySymbol = $('body').attr('data-currency');
    let currentRate = window.Shopify.currency.rate;
    wizardInfo = localStorage.getItem('wizardInfo_gemstone'); 
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let price;
    let priceStone;
    let settingSelected = false;
    let stoneSelected = false;
    if(window.location.href.indexOf('stone=') >-1){
       var stone_name = window.location.href.split('stone=')[1];
     } 
    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo); 
         price = currentCurrencySymbol+' '+toNumberFormat((wizardInfo.setting_variant_price/100));  
        priceStone = currentCurrencySymbol+' '+toNumberFormat(wizardInfo.gemstone_price * currentRate );
    }
    else {
        wizardInfo = wizard_gemstone;
    }
  if(wizardInfo != null){
    let stone_image_url = wizardInfo.gemstone_image_url;
     if(stone_image_url != null ){
    $('.banner_size_images').find('.banner_size_each img').attr('src',stone_image_url);
    }
  }
    switch (wizard_gemstone.stepId) {
        case 1:
            //console.log("Over here, wizardInfo", wizardInfo);
            // Let's validate if we have any selections in localStorage, if not, let's present the default
            document.getElementById("nro-1").innerHTML=1;
            document.getElementById("nro-2").innerHTML=2; 
            let step1 = document.getElementById("step1");
            step1.classList.add('step-select');
            stepPrev = document.getElementById("step0");
            stepPrev.classList.add('step-border');
          
            if(wizardInfo == null){    
               
                /**Step 1 selected */
                document.querySelector('.gemstone_wizard #title-1-step1').innerHTML = `Choose Setting`;
                document.querySelector('.gemstone_wizard #info-wizard-step-1').style.display="none";               
                document.querySelector('.gemstone_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('ring_image');
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-noSelected');
                /**Step 2 NO selected */
                //document.querySelector('.gemstone_wizard #col-step-2').classList.add('col-wizard-margin-Noselected');
                document.querySelector('.gemstone_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-1-noSelected gemstone_image');
                document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Gemstones`;
                document.querySelector('.gemstone_wizard #subtitle-1-step2').innerHTML = ` <a class="title-step title-middle" href="/pages/dyor-diamonds">Browse Gemstone</a>`;
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
                /**Step 3 NO selected */
                //document.querySelector('.gemstone_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                //document.querySelector('.gemstone_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="">Select Ring Size</a>`;
            }
            else {
                if(wizardInfo.setting_product_handle){
                    settingSelected = true;
                    document.querySelector('.gemstone_wizard #nro-1').innerHTML=1;
                   document.querySelector('.gemstone_wizard #nro-2').innerHTML=2; 
                    /**Step 1 selected */
                   document.querySelector('.gemstone_wizard #col-step-1').classList.add('col-wizard-margin-selected');
                    document.querySelector('.gemstone_wizard #info-wizard-step-1').classList.add('ring_title');
                    document.querySelector('.gemstone_wizard #info-wizard-step-1-2').classList.add('ring_price');
                    document.querySelector('.gemstone_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle view_product" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                    document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('ring_image');
                    document.querySelector('.gemstone_wizard #img-wizard-step1').src =`${wizardInfo.setting_image_url}`
                    document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-selected');
                    //document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-noSelected');
                }
                else {
                    /**Step 1 selected */
                    document.querySelector('.gemstone_wizard #title-1-step1').innerHTML = `Choose Setting`;
                    //document.querySelector('.gemstone_wizard #col-step-1').classList.add('col-wizard-margin-Noselected');
                    document.querySelector('.gemstone_wizard #info-wizard-step-1').style.display="none";               
                    document.querySelector('.gemstone_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                    document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('ring_image');
                    document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-noSelected');
                }
                if(wizardInfo.gemstone_id){
                    stoneSelected = true;
                    /**Step 2 selected */
                   /**Step 2 NO selected */
                    document.querySelector('.gemstone_wizard #col-step-2').classList.add('col-wizard-margin-selected');
                    document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Gemstones`;  
                    document.querySelector('.gemstone_wizard #info-wizard-step-2').classList.add('gemstone_title');
                    document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('gemstone_image');
                    document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-selected');
                    document.querySelector('.gemstone_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
                }
                else {
                    //document.querySelector('.gemstone_wizard #col-step-2').classList.add('col-wizard-margin-Noselected');
                    document.querySelector('.gemstone_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                    document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('gemstone_image');
                    document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-1-noSelected');
                    document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Gemstones`;
                    document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
                }
                if(wizardInfo.setting_variant_id && wizardInfo.gemstone_id){
                    //document.querySelector('.gemstone_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                   document.querySelector('.gemstone_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-gemstonering">Select Ring Size</a>`;
                }
                 /**Step 3 NO selected */
                 else {
                    //document.querySelector('.gemstone_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                   document.querySelector('.gemstone_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-gemstonering">Select Ring Size</a>`;
                 }
                
            }
            break;
        case 2:                 
            document.querySelector('.gemstone_wizard #nro-1').innerHTML=1;
            document.querySelector('.gemstone_wizard #nro-2').innerHTML=2;                                 
            let step2 = document.getElementById("step2");
            step2.classList.add('step-select');
            stepPrev = document.querySelector('.gemstone_wizard #step1');
            stepPrev.classList.add('step-border');

            document.querySelector('.gemstone_wizard #col-step-1').classList.add('col-wizard-margin-selected');
            document.querySelector('.gemstone_wizard #info-wizard-step-1').classList.add('ring_title');
            document.querySelector('.gemstone_wizard #info-wizard-step-1-2').classList.add('ring_price');
        if(window.location.href.indexOf('stone=') >-1){
          document.querySelector('.gemstone_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle view_product" href="/products/${wizardInfo.setting_product_handle}?product=gemstone&gemstone=${stone_name}">View </a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       

                   } else{
          document.querySelector('.gemstone_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle view_product" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View </a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
           
                   } 
                        document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('ring_image');
            var img_url = wizardInfo.setting_image_url; 
            checkImageExists(img_url, function(exists) {
            document.querySelector('.gemstone_wizard #img-wizard-step1').src =`${wizardInfo.setting_image_url}`
            })
            document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-selected');

            if(wizardInfo.gemstone_id){
               document.querySelector('.gemstone_wizard #col-step-2').classList.add('col-wizard-margin-selected');
                document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Gemstone`;       
                document.querySelector('.gemstone_wizard #info-wizard-step-2').classList.add('gemstone_title');
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('gemstone_image');
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-selected');
                document.querySelector('.gemstone_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
            }
            else {
               document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Gemstone`;
               document.querySelector('.gemstone_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
               document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-noSelected'); 
            }
            if(wizardInfo.setting_variant_id && wizardInfo.gemstone_id){
                document.querySelector('.gemstone_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-gemstonering">Select Ring Size</a>`;
            }
            else {
                //document.querySelector('.gemstone_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-gemstonering">Select Ring Size</a>`;
    
            }
            /**Step 3 NO selected */
          
            break;
        case 3:       
       
            document.querySelector('.gemstone_wizard #nro-1').innerHTML=1;
            document.querySelector('.gemstone_wizard #nro-2').innerHTML=2;       
            step3 = document.getElementById("step3");
            step3.classList.add('step-select-3');                
            /**Step 1 NO selected */
            document.querySelector('.gemstone_wizard #col-step-1').classList.add('col-wizard-margin-selected');
            document.querySelector('.gemstone_wizard #info-wizard-step-1').classList.add('ring_title');
            document.querySelector('.gemstone_wizard #info-wizard-step-1-2').classList.add('ring_price');
            document.querySelector('.gemstone_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle view_product" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
            document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('ring_image');
             var img_url = wizardInfo.setting_image_url; 
            checkImageExists(img_url, function(exists) {
            document.querySelector('.gemstone_wizard #img-wizard-step1').src =`${wizardInfo.setting_image_url}`;
            })
            document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-selected');
            /**Step 2 NO selected */
            document.querySelector('.gemstone_wizard #col-step-2').classList.add('col-wizard-margin-selected');
            document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Setting`;      
            document.querySelector('.gemstone_wizard #info-wizard-step-2').classList.add('gemstone_title');
            document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('gemstone_image');
            document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-selected');
            document.querySelector('.gemstone_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
           /**Step 3  selected */
            //document.querySelector('.gemstone_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
            document.querySelector('.gemstone_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-gemstonering">Select Ring Size</a>`;
            

            break;
        default:
            break;
    }
    
}

function loadDesktopStartWithDiamondWizard(){
    let wizardInfo;
    let currentCurrency = Shopify.currency.active;
    let currentCurrencySymbol = $('body').attr('data-currency');
    let currentRate = window.Shopify.currency.rate;
    wizardInfo = localStorage.getItem('wizardInfo_gemstone'); 
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let price;
    let priceStone;
    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo); 
      
        price = currentCurrencySymbol+' '+toNumberFormat((wizardInfo.setting_variant_price/100)); 
        priceStone = currentCurrencySymbol+' '+toNumberFormat(wizardInfo.gemstone_price * currentRate );
    }
    else {
        wizardInfo = wizard_gemstone;
    }
    if(wizardInfo != null){
    let stone_image_url = wizardInfo.gemstone_image_url;
     if(stone_image_url != null ){
    $('.banner_size_images').find('.banner_size_each img').attr('src',stone_image_url);
    }
  }
    switch (wizard_gemstone.stepId) {
        case 1:
            console.log('case 1')
            document.querySelector('.gemstone_wizard #nro-1').innerHTML=1;
            document.querySelector('.gemstone_wizard #nro-2').innerHTML=2;  
            let step1 = document.getElementById("step1");
            step1.classList.add('step-select');
            stepPrev = document.querySelector('.gemstone_wizard #step0');
            stepPrev.classList.add('step-border');
            if(wizardInfo.gemstone_id){
                document.querySelector('.gemstone_wizard #col-step-1').classList.add('col-wizard-margin-selected');
                document.querySelector('.gemstone_wizard #title-1-step1').innerHTML = `Choose Gemstones`;     
                document.querySelector('.gemstone_wizard #info-wizard-step-1').classList.add('gemstone_title');
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('gemstone_image');
                let step1Links = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View</a>`;
                step1Links += ` / <a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;
                
                document.querySelector('.gemstone_wizard #subtitle-1-step1').innerHTML = step1Links;
               document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-selected-diamond');
            }
            else {
                document.querySelector('.gemstone_wizard #title-1-step1').innerHTML = `Choose Gemstones`;
                document.querySelector('.gemstone_wizard #info-wizard-step-2').style.display="none";               
                document.querySelector('.gemstone_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-noSelected-diamond');
                
            }            
            /**Step 2 NO selected RING */
            if(wizardInfo.setting_product_handle){
              //document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Setting`;
              document.querySelector('.gemstone_wizard #title-1-step2').classList.add('col-wizard-margin-selected');
              document.querySelector('.gemstone_wizard #title-1-step2').classList.add('ring_title');
              document.querySelector('.gemstone_wizard #info-wizard-step-2').classList.add('ring_price');
              document.querySelector('.gemstone_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle view_product" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
             document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('ring_image');
              var img_url = wizardInfo.setting_image_url; 
              checkImageExists(img_url, function(exists) {
              document.querySelector('.gemstone_wizard #img-wizard-step2').src =`${wizardInfo.setting_image_url}`;
              })
              document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-selected');
              //document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-noSelected');
            }
            else {
                document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Setting`;
                //document.querySelector('.gemstone_wizard #col-step-2').classList.add('col-wizard-margin-Noselected');
                document.querySelector('.gemstone_wizard #info-wizard-step-2').classList.add('ring_price');
               document.querySelector('.gemstone_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
            }
            /**Step 3 NO selected */
            if(wizardInfo.setting_variant_id && wizardInfo.gemstone_id){
                //document.querySelector('.gemstone_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                document.querySelector('.gemstone_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-gemstonering">Select Ring Size</a>`;
            }
            else {
                //document.querySelector('.gemstone_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
            }
           
            
            break;
        case 2:
            console.log('case 2');

            document.querySelector('.gemstone_wizard #nro-1').innerHTML=1;
            document.querySelector('.gemstone_wizard #nro-2').innerHTML=2;  
            let step2 =  document.querySelector('.gemstone_wizard #step2');
            step2.classList.add('step-select');
            stepPrev = document.querySelector('.gemstone_wizard #step1');
            stepPrev.classList.add('step-border');

            if(wizardInfo.gemstone_id){
                document.querySelector('.gemstone_wizard #col-step-1').classList.add('col-wizard-margin-selected');
                document.querySelector('.gemstone_wizard #title-1-step1').innerHTML = `Choose Gemstones`;  
                document.querySelector('.gemstone_wizard #info-wizard-step-1').classList.add('gemstone_title');
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('gemstone_image');
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-selected-diamond');
                document.querySelector('.gemstone_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;
            }
            else {
                //document.querySelector('.gemstone_wizard #col-step-1').classList.add('col-wizard-margin-Noselected');
                document.querySelector('.gemstone_wizard #title-1-step1').innerHTML = `Choose Gemstones`;
                document.querySelector('.gemstone_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-noSelected-diamond'); 
            }

            if(wizardInfo.setting_product_handle){
                document.querySelector('.gemstone_wizard #title-1-step2').classList.add('col-wizard-margin-selected');
                document.querySelector('.gemstone_wizard #title-1-step2').innerHTML= `$`; 
                document.querySelector('.gemstone_wizard #info-wizard-step-2').classList.add('ring_price');
                document.querySelector('.gemstone_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle view_product" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('ring_image');
                var img_url = wizardInfo.setting_image_url; 
                checkImageExists(img_url, function(exists) {
                document.querySelector('.gemstone_wizard #img-wizard-step2').src =`${wizardInfo.setting_image_url}`;
                })
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-selected');
            }
            else {
              let pd_title = $('.product__info-wrapper .product__title.mb_6.small-hide h1').text();
              let main_price =  $('.product__info-container .price-item--regular').html();
              if(pd_title != ''){
                document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = pd_title;
                 document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Setting`;
              }
              var template = $('.product.non-dyor-product').attr('data-template');
              if(main_price != '' && template != 'gemstone'){
                document.querySelector('.gemstone_wizard #info-wizard-step-2').innerHTML = main_price; 
                document.querySelector('.gemstone_wizard #info-wizard-step-2').style.display="block";
              }else{
                   
                  document.querySelector('.gemstone_wizard #info-wizard-step-2').style.display="none";
              }
              if(pd_title != '' && main_price != ''){
              document.querySelector('.gemstone_wizard #subtitle-1-step2').innerHTML = ` <a class="title-step title-middle" onclick="changeWizardSelection('setting')">Change</a>`;
            }
                document.querySelector('.gemstone_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
            }
        
            /**Step 3 NO selected */
            if(wizardInfo.setting_variant_id && wizardInfo.gemstone_id){
                //document.querySelector('.gemstone_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                document.querySelector('.gemstone_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-gemstonering">Select Chain Length</a>`;
            }
            else {
                //document.querySelector('.gemstone_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');

            }
        
        
        
            break;                
        case 3:
            console.log('case 3');
             document.querySelector('.gemstone_wizard #nro-1').innerHTML=1;
             document.querySelector('.gemstone_wizard #nro-2').innerHTML=2;  

            step3 =  document.querySelector('.gemstone_wizard #step3');
            step3.classList.add('step-select-3');
            stepPrev =  document.querySelector('.gemstone_wizard #step2');
            stepPrev.classList.add('step-border');

           if(wizardInfo.gemstone_id){
                /**Step 2 selected */
               /**Step 2 NO selected */
                document.querySelector('.gemstone_wizard #col-step-1').classList.add('col-wizard-margin-selected');
                document.querySelector('.gemstone_wizard #title-1-step1').innerHTML = `Choose Gemstones`;           
                document.querySelector('.gemstone_wizard  #info-wizard-step-1').classList.add('gemstone_title');
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('gemstone_image');
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-selected-diamond');
                document.querySelector('.gemstone_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
            }
            else {
                //document.querySelector('.gemstone_wizard #col-step-1').classList.add('col-wizard-margin-Noselected');
                document.querySelector('.gemstone_wizard #title-1-step1').innerHTML = `Choose Gemstones`;
                //document.querySelector('.gemstone_wizard #subtitle-1-step2').innerHTML = ` <a class="title-step title-middle" href="/pages/dyor-diamonds">Browse Diamonds</a>`;
                document.querySelector('.gemstone_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-noSelected-diamond'); 
            }

            if(wizardInfo.setting_product_handle){
                //document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Setting`;
                document.querySelector('.gemstone_wizard #title-1-step2').classList.add('col-wizard-margin-selected');
                 document.querySelector('.gemstone_wizard #title-1-step2').classList.add('ring_title');
                document.querySelector('.gemstone_wizard #info-wizard-step-2').classList.add('ring-price');
                document.querySelector('.gemstone_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('ring_image');
                var img_url = wizardInfo.setting_image_url; 
                checkImageExists(img_url, function(exists) {
                document.querySelector('.gemstone_wizard #img-wizard-step2').src =`${wizardInfo.setting_image_url}`;
                })
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-selected');
              var img_url = wizardInfo.setting_image_url; 
            checkImageExists(img_url, function(exists) {
                document.querySelector('.gemstone_wizard #img-wizard-step2').src=`${wizardInfo.setting_image_url}`;
            })
                //document.querySelector('.gemstone_wizard #img-wizard-step1').classList.add('img-step-1-noSelected');
            }
            else {
                /**Step 2 selected */
                document.querySelector('.gemstone_wizard #title-1-step2').classList.add('ring_title');
                document.querySelector('.gemstone_wizard #title-1-step2').innerHTML = `Choose Setting`;
                //document.querySelector('.gemstone_wizard #col-step-2').classList.add('col-wizard-margin-Noselected');
                document.querySelector('.gemstone_wizard #info-wizard-step-2').classList.add('ring-price');
                document.querySelector('.gemstone_wizard #info-wizard-step-2').style.display="none";               
                document.querySelector('.gemstone_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                document.querySelector('.gemstone_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
            }
            /**Step 3 NO selected */
            //document.querySelector('.gemstone_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
            document.querySelector('.gemstone_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-gemstonering">Select Ring Size</a>`;

            break;
        default:
            break;
    }            


}
function loadMobileWizard(){
    let currentCurrency = Shopify.currency.active;
    let currentCurrencySymbol = $('body').attr('data-currency');
    let currentRate = window.Shopify.currency.rate;
    let wizardSessionDate = JSON.parse(localStorage.getItem('wizardSessionDate'));
    if(wizardSessionDate){
        // let's parse the date
        let date = new Date(wizardSessionDate);
        //if more than 4 hours have passed let's clear the wizard/localStorage and all that stuff
        if((new Date() - date) > 14400000){
            localStorage.removeItem('wizardInfo_dyop');
            localStorage.removeItem('wizardStart');
            localStorage.removeItem('wizardSessionDate');
            localStorage.removeItem('latestSearch');
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
        else {
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
    }
    else {
        // Not even a date, let's clear the localStorage
        localStorage.removeItem('wizardInfo_dyop');
        localStorage.removeItem('wizardStart');
        localStorage.removeItem('wizardSessionDate');
        localStorage.removeItem('latestSearch');
        localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));

    }
    let step1, stp2, step3;
    let choose1, choose2, choose3;
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));

let wizardInfo;
    wizardInfo = localStorage.getItem('wizardInfo_gemstone'); 
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let price;
    let priceStone;
    let settingSelected = false;
    let stoneSelected = false;
    
    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo); 
        
        price = currentCurrencySymbol+' '+toNumberFormat((wizardInfo.setting_variant_price/100) * currentRate); 
         priceStone = currentCurrencySymbol+' '+toNumberFormat(wizardInfo.stone_price * currentRate );
    }
    else {
        wizardInfo = wizard_gemstone;
    }
    if(wizardStart == 'StartWithDiamond'){
    switch (wizard_gemstone.stepId) {
      
        case 1:
        if(wizardInfo.gemstone_id){  
                  document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose Gemstones:`;  
                    document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting :`;
                    document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
                }else{
                 document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose Gemstones:`;  
                document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting :`;
                }
              if(wizardInfo.setting_product_handle){
                    settingSelected = true;
                     /**Step 1 selected */
                     document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose Gemstones:`;  
                    document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                    document.querySelector('.gemstone_wizard #subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                }else{
                 document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose Gemstones:`;  
                    document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                }
            break;
        case 2:
     if(wizardInfo.gemstone_id){  
               document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose Gemstones:`;  
                document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
               document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
            }
            else {
               document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose  Gemstones :`;  
                    document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
              document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML =`To Be Selected`
            }
           if(wizardInfo.setting_product_handle){
               document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose Setting :`;  
                document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Gemstones:`;
              document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
             }else {
               document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose Gemstones:`;  
                  document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
              document.querySelector('.gemstone_wizard #subtitle-1-step2_mob').innerHTML =`To Be Selected`
            }
            /**Step 3 NO selected */
          
            break;
        case 3:                
            /**Step 1 NO selected */
         if(wizardInfo.gemstone_id){  
              document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose  Gemstones :`;  
                document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
           document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
         }
            document.querySelector('.gemstone_wizard #subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                              
            
           /**Step 3  selected */
            break;
        default:
            break;
    }
    }else{
      switch (wizard_gemstone.stepId) {
        case 1:
               if(wizardInfo.gemstone_id){  
                  document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose  Gemstones :`;  
                    document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                    document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
                }else{
                 
                }
              if(wizardInfo.setting_product_handle){
                    settingSelected = true;
                     /**Step 1 selected */
                     document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose  Gemstones :`;  
                    document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                    document.querySelector('.gemstone_wizard #subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                }
            break;
        case 2:
        if(wizardInfo.gemstone_id){  
               document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose  Gemstones :`;  
                    document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
               document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
            }
            else {
               document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose  Gemstones :`;  
                    document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
              document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML =`To Be Selected`
            }
           if(wizardInfo.setting_product_handle){
               document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose Setting :`;  
                document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Gemstones:`;
              document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
             }else {
               document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose Setting :`;  
                  document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Gemstones:`;
              document.querySelector('.gemstone_wizard #subtitle-1-step2_mob').innerHTML =`To Be Selected`
            }
            /**Step 3 NO selected */
          
            break;
        case 3:     
            /**Step 1 NO selected */
         if(wizardInfo.gemstone_id){  
           document.querySelector('.gemstone_wizard #title-1-step1_mob').innerHTML = `Choose  Gemstones :`;  
           document.querySelector('.gemstone_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
           document.querySelector('.gemstone_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.gemstone_handle}?page=gemstone">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;
         }
            document.querySelector('.gemstone_wizard #subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}?product=gemstone">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                              
            
           /**Step 3  selected */
            break;
        default:
            break;
    } 
    }
}

loadWizard();
$(document).on('click','a.view_product',function(){
if($(this).attr('href').indexOf('products/') >-1){
  var product_handle = $(this).attr('href').split('products/')[1];
  localStorage.setItem("gemstone_template",`true,${product_handle}`);  
} 
})
 function setCookie(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value  + ';expires=' + expires.toUTCString();
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    function eraseCookie(key) {
        var keyValue = getCookie(key);
        setCookie(key, keyValue, '-1');
    }
$(window).on("load",function(){
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
    if(window.location.href.indexOf('?stone=') > -1){
    var cookie_path = window.location.href.split('?stone=')[1];
    let stp_popup_time =  getCookie(`st_popup_${cookie_path}`);
    if(stp_popup_time ==  null){
    var popup = $('.gemstone_wizard .steps_popup').attr('data-popup');
    if(wizardInfo == null && popup == 'true'){
     localStorage.setItem('st_popup_show_pdp',true)
     $('.gemstone_wizard .steps_popup').show();
    }
    }
    }
    $('.gemstone_wizard .steps_popup .close_btn').click(function(){
    if(window.location.href.indexOf('?stone=') > -1){
    var cookie_path = window.location.href.split('?stone=')[1];
    setCookie(`st_popup_${cookie_path}`,'true','1');
    $('.steps_popup').hide();
    }
    })
  $(document).mouseup(function(e) 
    {
    if(window.location.href.indexOf('/collections') > -1){
    var container1 = $(".gemstone_wizard .steps_popup");
    if(!$('.close_btn').is(e.target)){
      if (!container1.is(e.target) && container1.has(e.target).length === 0) 
      {
      $(container1).find('.close_btn').trigger('click');
      }
    }
    }
    if(window.location.href.indexOf('?product=gemstone') > -1){
      var container2 = $('.variants[filter="Diamond Shapes"] .steps_popup');
      if(!$('.close_btn').is(e.target)){
      if (!container2.is(e.target) && container2.has(e.target).length === 0) 
      {
      $(container2).find('.close_btn').trigger('click');
      }
    }
    }
    });   
  if(window.location.href.indexOf('?stone=') > -1){
   var stone_val = window.location.href.split('?stone=')[1];
    var collection_url = window.location.href.split('?stone=')[0]
    localStorage.setItem("stone_path",`${stone_val},${collection_url}`); 
  }
  $('.grid__item .slick-slide a').click(function(e){
  var stone_path = localStorage.getItem("stone_path");
    if(stone_path != null){
  stone_path_name = stone_path.split(',')[0];
  coll_path = stone_path.split(',')[1];
  if( window.location.href.indexOf(coll_path) > -1){
  e.preventDefault();
  var product_url = $(this).attr('href');
  if(product_url.indexOf('stone=') < 0){
  product_url = `${product_url}&stone=${stone_path_name}`;
  
  }else{
    product_url = `${product_url}`
  }
  window.location.href = product_url;
  localStorage.removeItem("stone_path")
  }
    }
  })
  let wizardInfo1 = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
  if(wizardInfo1 != null){
  fetch(window.API_URL+`diamonds/singleGemstone/${wizardInfo1.gemstone_id}`, {
        method: 'GET',
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json())
        .then(response => {
       var currentCurrencySymbol = $('body').attr('data-currency');
       var currentRate = window.Shopify.currency.rate;
       $('body').attr('gemstone-shape',response.Shape);
       $('body').attr('gemstone-title',response.Title);
       if(response.Image1 != null && response.Image1 != '' && response.Image1 != undefined){
       $('.gemstone_wizard .gemstone_image').attr('src',response.Image1).removeClass('hidden');
       }else{
        $('.gemstone_wizard .gemstone_image').remove(); 
       }
       $('.gemstone_wizard .gemstone_title').text(`${response.Title} - ${currentCurrencySymbol+''+toNumberFormat(response.Price2Total * currentRate)}`)
           //wizardInfo1.gemstone_shape = response.Shape;
        //localStorage.setItem('wizardInfo_gemstone', JSON.stringify(wizardInfo1));
      });
     $.ajax({
    url: `https://my-solitaire.myshopify.com/products/${wizardInfo1.setting_product_handle}?view=inventory`,
    type: 'GET',
    success: function(res) {
     $('body').attr('sku',$(res).find('.product_transprancy_pricing[data-id="'+wizardInfo1.setting_variant_id+'"]').attr('v_sku'));
     $('body').attr('p_id',$(res).find('.product_transprancy_pricing[data-id="'+wizardInfo1.setting_variant_id+'"]').attr('p_id'));
     let currentCurrencySymbol = $('body').attr('data-currency');
     var amt=$(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+wizardInfo1.setting_variant_id+'"]').attr('data-price-main');  
     console.log("<<<<<<<amt");
     console.log(amt);
     if(amt!=undefined){
         $('.ring-price,.ring_price').text(currentCurrencySymbol+$(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+wizardInfo1.setting_variant_id+'"]').attr('data-price-main'));
     }  
     $('.ring_title').text($(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+wizardInfo1.setting_variant_id+'"]').attr('product-name'))
    }
    })
  }
  
    let screenWidth = screen.width;
    wizardStart = JSON.parse(localStorage.getItem('wizardStart'));  
    if (screenWidth >= 800) {
        switch (wizardStart) {
            case 'StartWithSetting':        
                loadDesktopStartWithSettingWizard();
                break;

            case 'StartWithDiamond':
                setTimeout(function(){
                loadDesktopStartWithDiamondWizard();
                  },1000)
                break;

            default:
                break;
        }
    } else {
        loadMobileWizard();
        }
});
function checkImageExists(imageUrl, callback) {
    var img = new Image();
    img.onload = function() {
        // The image loaded successfully
        callback(true);
    };
    img.onerror = function() {
        // The image could not be loaded
        callback(false);
    };
    img.src = imageUrl;
}